/* eslint-disable no-empty-pattern */
import { useEffect, useState, useRef } from "react";
import {
  dashboard_invoice_green_tick,
  dashboard_invoice_order_date,
  dashboard_invoice_order_history,
  merchant_dashboard_location_icon,
  pdf,
  manage_my_info_edit_logo,
} from "../../../assets/images";

import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../../services/axios.instance";

import { API_URL } from "../../../services/apiConfig";
import { trackEvent } from "../../../services/events";
import ReactPixel from "react-facebook-pixel";
import { useForm } from "react-hook-form";

import { useLocation, useNavigate } from "react-router-dom";
import ImagePopupModal from "../../MerchantDashboard/ImagePopupModal";
import { Carousel } from "react-bootstrap";

import { OverlayTrigger, Popover } from "react-bootstrap";
import { toast } from "react-toastify";

const usePdfDownload = () => {
  const downloadPdf = async (name: string, url: string) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = `${name}.pdf`;
    link.target = "_self";
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return {
    loading: false,
    downloadedUri: null as string | null,
    lastFileName: null as string | null,
    downloadPdf,
    clearBanner: () => {},
  };
};

const CustomerOrderDetails = () => {
  const location = useLocation();
  const OrderId = new URLSearchParams(location.search).get("OrderId");

  // console.log("new", OrderId);
  const { data: invoiceDetails } = useQuery({
    queryKey: ["invoiceDetails", OrderId],
    queryFn: async () => {
      const response = await axiosInstance.get(
        `${API_URL.CUSTOMER_ORDER_DETAILS}/${OrderId}/details`,
        {
          headers: {
            location: "0,0",
            language: "english",
          },
        },
      );
      return response.data;
    },
  });
  const { data: commentMessage } = useQuery({
    queryKey: ["commentMessage", OrderId],
    queryFn: async () => {
      const response = await axiosInstance.get(
        `${API_URL.GET_COMMENTS}/${OrderId}`,
      );
      // console.log("commentMessagestatuss", commentMessage);
      return response.data;
    },
  });

  const {
    formState: { },
  } = useForm({ mode: "onChange" });

  //------------------------------------------------------------------------

  // const handlePlateNumberChange = (value: React.SetStateAction<string>) => {
  //   setPlateNumber(value);
  //   setPlateNumberError("");
  // };

  // const handleDeliveryBoyNumberChange = (
  //   value: React.SetStateAction<string>
  // ) => {
  //   setDeliveryBoyPhone(value);
  // };

  // const handleDeliveryBoyNameChange = (value: React.SetStateAction<string>) => {
  //   setDeliveryBoyName(value);
  // };

  //--------------------------------------------------------------------------

  const formatDate = (isoDate: any) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${day}-${month}-${year}, ${hours}:${minutes}:${seconds}`;
  };

  const [showImagePopupModal, setShowImagePopupModal] = useState(false);

  // const handleimagepopover = () => {
  //   setShowImagePopupModal(true);
  // };

  // const handleClose = () => {
  //   setLoadModal(false);
  // };

  // const [loadModal, setLoadModal] = useState(false);
  const [imageSource, setImageSource] = useState("");

  useEffect(() => {
    if (invoiceDetails?.customer_details?.customerDocs) {
      const customerDocs = invoiceDetails?.customer_details?.customerDocs;

      const emiritiesDocs = Object.keys(customerDocs)?.filter((key) =>
        key.startsWith("EMIRITIES"),
      );

      emiritiesDocs?.forEach((docKey) => {
        const documentId = customerDocs[docKey];

        if (documentId !== undefined && documentId !== null) {
          axiosInstance
            .get(`${API_URL.CUSTOMER_DOCUMENTS}/${documentId}`, {
              responseType: "arraybuffer",
            })
            .then((response) => {
              if (response && response.data) {
                const contentType = String(response.headers["content-type"] || "");
                const isPdf = contentType === "application/pdf";
                const isImage = contentType.startsWith("image/");

                if (isPdf) {
                  const blob = new Blob([response.data], {
                    type: "application/pdf",
                  });
                  const objectUrl = URL.createObjectURL(blob);

                  const downloadLink = document.getElementById(
                    `${docKey}DownloadLink`,
                  ) as HTMLAnchorElement;
                  downloadLink.href = objectUrl;
                  downloadLink.style.display = "block";
                  downloadLink.download = `${docKey}.pdf`;

                  const imageElement = document.getElementById(
                    `${docKey}_IMAGE`,
                  ) as HTMLImageElement;
                  imageElement.src = pdf;
                } else if (isImage) {
                  const blob = new Blob([response.data], { type: contentType });
                  const imageUrl = URL.createObjectURL(blob);

                  const imageElement = document.getElementById(
                    `${docKey}_IMAGE`,
                  ) as HTMLImageElement;
                  imageElement.src = imageUrl;
                  imageElement.onclick = () => {
                    setImageSource(imageUrl);
                    setShowImagePopupModal(true);
                  };

                  const imageSizeKB = response.data.byteLength / 1000;
                  // console.log(`${docKey} Image Size:`, imageSizeKB, "KB");
                }
              } else {
                console.error(`Failed to fetch document for ${docKey}`);
              }
            })
            .catch((error) => {
              console.error(`Error fetching ${docKey}:`, error);
            });
        } else {
          console.warn(`Document ID for ${docKey} is null or undefined`);
        }
      });
    }
  }, [invoiceDetails]);

  useEffect(() => {
    if (invoiceDetails?.customer_details?.customerDocs) {
      const customerDocs = invoiceDetails?.customer_details?.customerDocs;

      const licenseDocs = Object.keys(customerDocs).filter((key) =>
        key.startsWith("LICENSE"),
      );

      licenseDocs.forEach((docKey) => {
        const documentId = customerDocs[docKey];

        if (documentId !== undefined && documentId !== null) {
          axiosInstance
            .get(`${API_URL.CUSTOMER_DOCUMENTS}/${documentId}`, {
              responseType: "arraybuffer",
            })
            .then((response) => {
              if (response && response.data) {
                const contentType = String(response.headers["content-type"] || "");
                const isPdf = contentType === "application/pdf";
                const isImage = contentType.startsWith("image/");

                if (isPdf) {
                  const blob = new Blob([response.data], {
                    type: "application/pdf",
                  });
                  const objectUrl = URL.createObjectURL(blob);

                  const downloadLink = document.getElementById(
                    `${docKey}DownloadLink`,
                  ) as HTMLAnchorElement;
                  downloadLink.href = objectUrl;
                  downloadLink.style.display = "block";
                  downloadLink.download = `${docKey}.pdf`;

                  const imageElement = document.getElementById(
                    `${docKey}_IMAGE`,
                  ) as HTMLImageElement;
                  imageElement.src = pdf;
                } else if (isImage) {
                  const blob = new Blob([response.data], { type: contentType });
                  const imageUrl = URL.createObjectURL(blob);

                  const imageElement = document.getElementById(
                    `${docKey}_IMAGE`,
                  ) as HTMLImageElement;
                  imageElement.src = imageUrl;
                  imageElement.onclick = () => {
                    setImageSource(imageUrl);
                    setShowImagePopupModal(true);
                  };

                  const imageSizeKB = response.data.byteLength / 1000;
                  // console.log(`${docKey} Image Size:`, imageSizeKB, "KB");
                }
              } else {
                console.error(`Failed to fetch document for ${docKey}`);
              }
            })
            .catch((error) => {
              console.error(`Error fetching ${docKey}:`, error);
            });
        } else {
          console.warn(`Document ID for ${docKey} is null or undefined`);
        }
      });
    }
  }, [invoiceDetails]);

  useEffect(() => {
    if (invoiceDetails?.customer_details?.customerDocs) {
      const customerDocs = invoiceDetails?.customer_details?.customerDocs;

      const visaDocs = Object.keys(customerDocs)?.filter((key) =>
        key.startsWith("VisitVisa"),
      );

      visaDocs?.forEach((docKey) => {
        const documentId = customerDocs[docKey];

        if (documentId !== undefined && documentId !== null) {
          axiosInstance
            .get(`${API_URL.CUSTOMER_DOCUMENTS}/${documentId}`, {
              responseType: "arraybuffer",
            })
            .then((response) => {
              if (response && response.data) {
                const contentType = String(response.headers["content-type"] || "");
                const isPdf = contentType === "application/pdf";
                const isImage = contentType.startsWith("image/");

                if (isPdf) {
                  const blob = new Blob([response.data], {
                    type: "application/pdf",
                  });
                  const objectUrl = URL.createObjectURL(blob);

                  const downloadLink = document.getElementById(
                    `${docKey}DownloadLink`,
                  ) as HTMLAnchorElement;
                  downloadLink.href = objectUrl;
                  downloadLink.style.display = "block";
                  downloadLink.download = `${docKey}.pdf`;

                  const imageElement = document.getElementById(
                    `${docKey}_IMAGE`,
                  ) as HTMLImageElement;
                  imageElement.src = pdf;
                } else if (isImage) {
                  const blob = new Blob([response.data], { type: contentType });
                  const imageUrl = URL.createObjectURL(blob);

                  const imageElement = document.getElementById(
                    `${docKey}_IMAGE`,
                  ) as HTMLImageElement;
                  imageElement.src = imageUrl;
                  imageElement.onclick = () => {
                    setImageSource(imageUrl);
                    setShowImagePopupModal(true);
                  };

                  const imageSizeKB = response.data.byteLength / 1000;
                  // console.log(`${docKey} Image Size:`, imageSizeKB, "KB");
                }
              } else {
                console.error(`Failed to fetch document for ${docKey}`);
              }
            })
            .catch((error) => {
              console.error(`Error fetching ${docKey}:`, error);
            });
        } else {
          console.warn(`Document ID for ${docKey} is null or undefined`);
        }
      });
    }
  }, [invoiceDetails]);

  useEffect(() => {
    if (invoiceDetails?.customer_details?.customerDocs) {
      const customerDocs = invoiceDetails?.customer_details?.customerDocs;

      const PassportDocs = Object.keys(customerDocs)?.filter((key) =>
        key.startsWith("Passport"),
      );

      PassportDocs?.forEach((docKey) => {
        const documentId = customerDocs[docKey];

        if (documentId !== undefined && documentId !== null) {
          axiosInstance
            .get(`${API_URL.CUSTOMER_DOCUMENTS}/${documentId}`, {
              responseType: "arraybuffer",
            })
            .then((response) => {
              if (response && response.data) {
                const contentType = String(response.headers["content-type"] || "");
                const isPdf = contentType === "application/pdf";
                const isImage = contentType.startsWith("image/");

                if (isPdf) {
                  const blob = new Blob([response.data], {
                    type: "application/pdf",
                  });
                  const objectUrl = URL.createObjectURL(blob);

                  const downloadLink = document.getElementById(
                    `${docKey}DownloadLink`,
                  ) as HTMLAnchorElement;
                  downloadLink.href = objectUrl;
                  downloadLink.style.display = "block";
                  downloadLink.download = `${docKey}.pdf`;

                  const imageElement = document.getElementById(
                    `${docKey}_IMAGE`,
                  ) as HTMLImageElement;
                  imageElement.src = pdf;
                } else if (isImage) {
                  const blob = new Blob([response.data], { type: contentType });
                  const imageUrl = URL.createObjectURL(blob);

                  const imageElement = document.getElementById(
                    `${docKey}_IMAGE`,
                  ) as HTMLImageElement;
                  imageElement.src = imageUrl;
                  imageElement.onclick = () => {
                    setImageSource(imageUrl);
                    setShowImagePopupModal(true);
                  };

                  const imageSizeKB = response.data.byteLength / 1000;
                  // console.log(`${docKey} Image Size:`, imageSizeKB, "KB");
                }
              } else {
                console.error(`Failed to fetch document for ${docKey}`);
              }
            })
            .catch((error) => {
              console.error(`Error fetching ${docKey}:`, error);
            });
        } else {
          console.warn(`Document ID for ${docKey} is null or undefined`);
        }
      });
    }
  }, [invoiceDetails]);

  // const [dateTime, setDateTime] = useState("");
  const [minDateTime, setMinDateTime] = useState("");

  useEffect(() => {
    const now = new Date();
    const isoString = now.toISOString().substring(0, 16);
    setMinDateTime(isoString);
  }, []);

  useEffect(() => {
    const trackPageLoad = async () => {
      if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
        ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
      }
      ReactPixel.track("ViewContent", {
        content_type: "page",
        content_name: "Order Details Screen",
        content_category: "OrderHistory",
        order_id: OrderId,
      });
      await trackEvent({
        event_name: {
          web: "Kirkos_OrderHistoryOrderDetailsScreen",
          app: "Kirkos_OrderHistoryOrderDetailsScreen_App",
        },
        event_category: "OrderHistory_Info",
        module: "OrderHistory",
        payload: {},
      });
    };
    trackPageLoad();
  }, []);

  //----------------------------------------------------------------------------------------

  // const handleUploadDeleteImage = (index: any, type: any) => {
  //   if (type === "vdr") {
  //     setVdrUploadedImages((prevImages) =>
  //       prevImages.filter((_, i) => i !== index)
  //     );
  //   } else if (type === "rentalAgreement") {
  //     setRentalAgreementUploadedImages((prevImages) =>
  //       prevImages.filter((_, i) => i !== index)
  //     );
  //   }
  // };

  // const formatTime = (dateTimeString: string) => {
  //   const date = new Date(dateTimeString);
  //   return date.toLocaleTimeString([], {
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     hourCycle: "h23",
  //   });
  // };

  // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.files) {
  //     handleImageUpload(e.target.files);
  //   }
  // };
  //-----------------------------------------------------------------------------------------

  const handleDownloadInvoice = async () => {
    try {
      if (!invoiceDetails) {
        console.error("Invoice details not available");
        toast.error("Invoice details not available");
        return;
      }
      const invoiceData = invoiceDetails?.order_invoice_data;
      const paymentInitiatedUrls = invoiceData?.PAYMENT_INITIATED;

      if (
        !paymentInitiatedUrls ||
        !Array.isArray(paymentInitiatedUrls) ||
        paymentInitiatedUrls.length === 0
      ) {
        console.error(
          "Invoice URL not available - PAYMENT_INITIATED data is missing",
        );
        toast.error("Invoice is not available yet. Please try again later.");
        return;
      }

      if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
        ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
      }
      ReactPixel.track("Purchase", {
        content_type: "invoice",
        content_name: "Order Invoice Downloaded",
        content_category: "OrderHistory",
        order_id: OrderId,
      });
      await trackEvent({
        event_name: {
          web: "Kirkos_OrderHistory_OrderInvoice_Downloaded",
          app: "Kirkos_OrderHistory_OrderInvoice_Downloaded_App",
        },
        event_category: "OrderHistory_Info",
        module: "OrderHistory",
        payload: {},
      });
      const invoiceUrl = paymentInitiatedUrls[0];
      await downloadPdf("Invoice", invoiceUrl);
    } catch (err) {
      console.error("Failed to open invoice:", err);
      toast.error("Failed to open invoice. Please try again.");
    }
  };
  const refpopup = useRef(null);
  const navigate = useNavigate();
  const { loading, downloadedUri, lastFileName, downloadPdf, clearBanner } =
    usePdfDownload();
  const overlayStyle = {
    position: "fixed",
    inset: 0 as any,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  };
  const spinnerStyle = {
    width: 40,
    height: 40,
    border: "4px solid #eee",
    borderTop: "4px solid #000",
    borderRadius: "50%",
  };
  const bannerStyle = {
    position: "fixed",
    bottom: 20,
    left: 16,
    right: 16,
    background: "#5f5c5cff",
    color: "#fff",
    padding: "12px 16px",
    borderRadius: 8,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: 9999,
  };
  const viewButtonStyle = {
    background: "transparent",
    border: "none",
    color: "#f5b719ff",
    fontWeight: "bold" as const,
    cursor: "pointer",
  };

  const popoverHoverFocus = (
    <Popover id="popover-trigger-hover-focus" className="popover-custom-edit">
      <Popover.Body className="d-flex align-items-center">
        <span className="invoice-div-data text-light">
          Edited by Kirkos backoffice
        </span>
      </Popover.Body>
    </Popover>
  );

  return (
    <>
      {loading && (
        <div style={overlayStyle as any}>
          <div style={spinnerStyle as any} />
          <p className="text-light">Downloading invoice…</p>
        </div>
      )}
      {downloadedUri && (
        <div style={bannerStyle as any}>
          <span>
            Invoice downloaded
            {/* <span style={{ display: "block", fontSize: 12, color: "#b8b3b3" }}>
              Location: {lastFileName ?? ""}
            </span> */}
            <span style={{ display: "block", fontSize: 11, color: "#888" }}>
              {downloadedUri}
            </span>
          </span>
          <div>
            <button
              onClick={() => {
                const q = new URLSearchParams({
                  name: "Invoice",
                  uri: downloadedUri,
                  mime: "application/pdf",
                }).toString();
                navigate(`/customer/documents/view?${q}`);
                clearBanner();
              }}
              style={{ ...(viewButtonStyle as any), padding: "8px 12px" }}
            >
              VIEW
            </button>
            <button
              onClick={() => clearBanner()}
              style={{ ...(viewButtonStyle as any), color: "#bbb" }}
            >
              DISMISS
            </button>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-md-12 text-start div-bg-invoice-details ">
          <div className="card card-bg-invoice-details" ref={refpopup}>
            <div className="card-body px-5">
              <div className="row   pb-3">
                <div className="col-md-6 pt-4">
                  <table className="invoice-table-width">
                    <tr className="invoice-table-tr-first">
                      <td className="invoice-table-td">Order Number #</td>
                      <td>Order Created At</td>
                    </tr>
                    <tr>
                      <td className="invoice-text-yellow">
                        {invoiceDetails?.orderId}
                      </td>
                      <td>{formatDate(invoiceDetails?.createdAt)}</td>
                    </tr>
                  </table>

                  <div className="col-md-12 pt-3">
                    <div className="col-md-6 pt-2 pb-2">
                      <Carousel className="managemycarlist" controls={false}>
                        {invoiceDetails?.products?.[0]?.productImageUrls?.map(
                          (imageUrl: any, index: number) => (
                            <Carousel.Item
                              className="image-managemycar-height"
                              key={index}
                            >
                              <img
                                className="img-merchant-managecar"
                                src={imageUrl}
                                alt={`Product Image ${index + 1}`}
                              />
                            </Carousel.Item>
                          ),
                        )}
                      </Carousel>
                    </div>
                    {/* <div className="invoice-text-yellow d-flex align-items-center"> */}
                    <div
                      className={`invoice-text-yellow d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags?.productId
                        ? "text-danger"
                        : ""
                        }`}
                    >
                      {invoiceDetails?.products?.[0]?.productName}
                      {invoiceDetails?.modified_field_flags?.productId && (
                        <OverlayTrigger
                          container={refpopup}
                          trigger={["hover"]}
                          placement="top"
                          overlay={popoverHoverFocus}
                        >
                          <div className="ps-2">
                            <img
                              src={manage_my_info_edit_logo}
                              alt="Edit"
                              width="18"
                            />
                          </div>
                        </OverlayTrigger>
                      )}
                    </div>
                  </div>

                  <div
                    className={`col-md-12 invoice-div-head pt-3 d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags
                      ?.delivery_location
                      ? "text-danger"
                      : ""
                      }`}
                  >
                    Location
                    {invoiceDetails?.modified_field_flags
                      ?.delivery_location && (
                        <OverlayTrigger
                          container={refpopup}
                          trigger={["hover"]}
                          placement="top"
                          overlay={popoverHoverFocus}
                        >
                          <div className="ps-2">
                            <img
                              src={manage_my_info_edit_logo}
                              alt="Edit"
                              width="18"
                            />
                          </div>
                        </OverlayTrigger>
                      )}
                  </div>
                  <div className="col-md-12 invoice-div-data">
                    {invoiceDetails?.delivery_location?.address}
                  </div>

                  <div
                    className={`col-md-12 invoice-div-head pt-3 d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags?.rental_days
                      ? "text-danger"
                      : ""
                      }`}
                  >
                    Initial Number of Days Ordered
                    {invoiceDetails?.modified_field_flags?.rental_days && (
                      <OverlayTrigger
                        container={refpopup}
                        trigger={["hover"]}
                        placement="top"
                        overlay={popoverHoverFocus}
                      >
                        <div className="ps-2">
                          <img
                            src={manage_my_info_edit_logo}
                            alt="Edit"
                            width="18"
                          />
                        </div>
                      </OverlayTrigger>
                    )}
                  </div>
                  <div className="col-md-12 invoice-div-data">
                    {invoiceDetails?.rental_days -
                      (invoiceDetails?.extended_rental_days || 0)}
                  </div>

                  {invoiceDetails?.extended_rental_days !== null &&
                    invoiceDetails?.extended_rental_days !== 0 && (
                      <>
                        <div className="col-md-12 invoice-div-head pt-3">
                          Extended Rental Days
                        </div>
                        <div className="col-md-12 invoice-div-data">
                          {invoiceDetails?.extended_rental_days}
                        </div>
                        <div className="col-md-12 invoice-div-head pt-3">
                          Total Rental Days
                        </div>
                        <div className="col-md-12 invoice-div-data">
                          {invoiceDetails?.rental_days}
                        </div>
                      </>
                    )}

                  <div className="col-md-12 invoice-div-head pt-3">
                    Merchant Name
                  </div>
                  <div className="col-md-12 invoice-div-data">
                    {invoiceDetails?.merchantDetails?.shop_info?.shop_name}
                  </div>
                  <div className="col-md-12 invoice-div-head pt-3">
                    Merchant Mail
                  </div>
                  <div className="col-md-12 invoice-div-data">
                    {invoiceDetails?.merchantDetails?.merchant_info?.email}
                  </div>
                  <div className="col-md-12 invoice-div-head pt-3">
                    Payment Status
                  </div>
                  <div className="col-md-12 invoice-div-data">
                    {invoiceDetails?.payment_status}
                  </div>
                  <div className="col-md-12 invoice-div-head pt-3">
                    Payment Method
                  </div>
                  <div className="col-md-12 invoice-div-data">
                    {invoiceDetails?.payment_method}
                  </div>
                  <div className="col-md-12 invoice-div-head pt-3">
                    Paid Amount
                  </div>

                  <div className="col-md-12 invoice-div-data">
                    {invoiceDetails?.order_total_amount?.toFixed(2)}
                  </div>

                  {/* <div className="col-md-12 invoice-div-head pt-3">
                  For Vehicle Provider
                </div>
                <div className="col-md-12 invoice-div-data">
                  {(
                    (invoiceDetails?.order_total_amount || 0) -
                    (invoiceDetails?.platform_charge || 0)
                  ).toFixed(2)}
                </div> */}
                </div>
                <div className="col-md-6 border-start-invoice-details pt-4">
                  <div className="col-md-12 invoice-div-head">
                    Customer Name
                  </div>
                  <div className="col-md-12 invoice-div-data">
                    {invoiceDetails?.customer_name}
                  </div>

                  <div className="col-md-12 invoice-div-head pt-3">
                    Customer Phone Number
                  </div>
                  <div className="col-md-12 invoice-div-data">
                    {invoiceDetails?.customer_phone_number}
                  </div>
                  <div>
                    {/* <div className="col-md-12 invoice-div-head pt-3">
                      Delivery Time
                    </div>
                    <div className="col-md-12 invoice-div-data">
                      {invoiceDetails?.delivery_preferred_time}
                    </div> */}
                    {invoiceDetails?.delivered_by === "CUSTOMER" && (
                      <>
                        <div
                          className={`col-md-12 invoice-div-head pt-3 d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags
                            ?.delivered_by
                            ? "text-danger"
                            : ""
                            }`}
                        >
                          Pickup By
                          {invoiceDetails?.modified_field_flags
                            ?.delivered_by && (
                              <OverlayTrigger
                                container={refpopup}
                                trigger={["hover"]}
                                placement="top"
                                overlay={popoverHoverFocus}
                              >
                                <div className="ps-2">
                                  <img
                                    src={manage_my_info_edit_logo}
                                    alt="Edit"
                                    width="18"
                                  />
                                </div>
                              </OverlayTrigger>
                            )}
                        </div>
                        <div className="col-md-12 invoice-div-data">
                          {invoiceDetails?.delivered_by}
                        </div>
                      </>
                    )}
                    {invoiceDetails?.delivered_by === "KIRKOS_EXECUTIVE" && (
                      <>
                        <div
                          className={`col-md-12 invoice-div-head pt-3 d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags
                            ?.delivered_by
                            ? "text-danger"
                            : ""
                            }`}
                        >
                          Delivery By
                          {invoiceDetails?.modified_field_flags
                            ?.delivered_by && (
                              <OverlayTrigger
                                container={refpopup}
                                trigger={["hover"]}
                                placement="top"
                                overlay={popoverHoverFocus}
                              >
                                <div className="ps-2">
                                  <img
                                    src={manage_my_info_edit_logo}
                                    alt="Edit"
                                    width="18"
                                  />
                                </div>
                              </OverlayTrigger>
                            )}
                        </div>
                        <div className="col-md-12 invoice-div-data">
                          {invoiceDetails?.delivered_by}
                        </div>
                      </>
                    )}
                    <div
                      className={`col-md-12 invoice-div-head d-flex align-items-center pt-3 ${invoiceDetails?.latest_modified_field_flags?.babySeat ||
                        invoiceDetails?.latest_modified_field_flags
                          ?.additionalDriver ||
                        invoiceDetails?.latest_modified_field_flags
                          ?.cdwAmount ||
                        invoiceDetails?.latest_modified_field_flags
                          ?.windShieldProtection ||
                        invoiceDetails?.latest_modified_field_flags
                          ?.scdwAmount ||
                        invoiceDetails?.latest_modified_field_flags
                          ?.paiInsuranceAmount
                        ? "text-danger"
                        : ""
                        }`}
                    >
                      Additional Options
                      {(invoiceDetails?.modified_field_flags?.babySeat ||
                        invoiceDetails?.modified_field_flags
                          ?.additionalDriver ||
                        invoiceDetails?.modified_field_flags?.cdwAmount ||
                        invoiceDetails?.modified_field_flags
                          ?.windShieldProtection ||
                        invoiceDetails?.modified_field_flags?.scdwAmount ||
                        invoiceDetails?.modified_field_flags
                          ?.paiInsuranceAmount) && (
                          <OverlayTrigger
                            container={refpopup}
                            trigger={["hover"]}
                            placement="top"
                            overlay={popoverHoverFocus}
                          >
                            <div className="ps-2">
                              <img
                                src={manage_my_info_edit_logo}
                                alt="Edit"
                                width="18"
                              />
                            </div>
                          </OverlayTrigger>
                        )}
                    </div>

                    <div className="col-md-12 invoice-div-data">
                      <ul
                        style={{
                          paddingLeft: "20px",
                          marginBottom: "0",
                          lineHeight: "1.8",
                        }}
                      >
                        {invoiceDetails?.products[0]?.babySeatAmount !== 0 &&
                          invoiceDetails?.products[0]?.babySeatAmount !==
                          null && (
                            <li style={{ marginBottom: "8px" }}>Baby Seat</li>
                          )}{" "}
                        {invoiceDetails?.products[0]?.paiInsuranceAmount !==
                          0 &&
                          invoiceDetails?.products[0]?.paiInsuranceAmount !==
                          null && (
                            <li style={{ marginBottom: "8px" }}>
                              PAI Insurance
                            </li>
                          )}{" "}
                        {invoiceDetails?.products[0]?.windShieldProtection !==
                          0 &&
                          invoiceDetails?.products[0]?.windShieldProtection !==
                          null && (
                            <li style={{ marginBottom: "8px" }}>
                              WindShield Protection
                            </li>
                          )}{" "}
                        {invoiceDetails?.products[0]?.additionalDriverAmount !==
                          0 &&
                          invoiceDetails?.products[0]
                            ?.additionalDriverAmount !== null && (
                            <li style={{ marginBottom: "8px" }}>
                              Additional Driver
                            </li>
                          )}{" "}
                        {invoiceDetails?.products[0]?.scdwAmount !== 0 &&
                          invoiceDetails?.products[0]?.scdwAmount !== null && (
                            <li style={{ marginBottom: "8px" }}>
                              SCDW Insurance
                            </li>
                          )}{" "}
                        {invoiceDetails?.products[0]?.cdwAmount !== 0 &&
                          invoiceDetails?.products[0]?.cdwAmount !== null && (
                            <li style={{ marginBottom: "8px" }}>
                              CDW Insurance
                            </li>
                          )}{" "}
                      </ul>
                    </div>
                  </div>
                  <div className="row pt-3">
                    <div className="col-12 pt-5">
                      <div className="order-history-card">
                        <div className="order-history-header">
                          <div className="d-flex align-items-center gap-3">
                            <div className="order-history-icon-wrapper">
                              <img src={dashboard_invoice_order_history} height={"20px"} alt="Order History" />
                            </div>
                            <h3 className="order-history-title">Order History</h3>
                          </div>
                        </div>

                        <div className="order-history-body">
                          {/* Timeline Container */}
                          <div className="order-timeline">
                            {/* Purchase Order Date */}
                            <div className="timeline-item">
                              <div className="timeline-icon-container">
                                <div className="timeline-icon">
                                  <img src={dashboard_invoice_order_date} height={"20px"} alt="Date" />
                                </div>
                                <div className="timeline-line"></div>
                              </div>
                              <div className="timeline-content">
                                <div className="timeline-label">Purchase Order Date</div>
                                <div className="timeline-value">{formatDate(invoiceDetails?.createdAt)}</div>
                              </div>
                            </div>

                            {/* Status */}
                            <div className="timeline-item">
                              <div className="timeline-icon-container">
                                <div className="timeline-icon status-icon">
                                  <img src={dashboard_invoice_green_tick} height={"20px"} alt="Status" />
                                </div>
                                <div className="timeline-line"></div>
                              </div>
                              <div className="timeline-content">
                                <div className="timeline-label">Status</div>
                                <div className="timeline-value status-value">{invoiceDetails?.orderStatus}</div>
                              </div>
                            </div>

                            {/* Delivery Date & Location */}
                            <div className="timeline-item">
                              <div className="timeline-icon-container">
                                <div className="timeline-icon">
                                  <img src={merchant_dashboard_location_icon} height={"20px"} alt="Location" />
                                </div>
                                <div className="timeline-line"></div>
                              </div>
                              <div className="timeline-content">
                                <div className={`timeline-label d-flex align-items-center gap-2 ${invoiceDetails?.latest_modified_field_flags?.delivery_location || invoiceDetails?.latest_modified_field_flags?.delivery_date ? "text-danger" : ""}`}>
                                  <span>Delivery Date & Location</span>
                                  {(invoiceDetails?.modified_field_flags?.delivery_location || invoiceDetails?.modified_field_flags?.delivery_date) && (
                                    <OverlayTrigger container={refpopup} trigger={["hover"]} placement="top" overlay={popoverHoverFocus}>
                                      <img src={manage_my_info_edit_logo} alt="Edit" width="16" className="edit-indicator" />
                                    </OverlayTrigger>
                                  )}
                                </div>
                                <div className="timeline-value location-value">
                                  <span className="timeline-date">{formatDate(invoiceDetails?.delivery_date)}</span>
                                  <span className="timeline-separator">|</span>
                                  <span className="timeline-address">{invoiceDetails?.delivery_location?.address}</span>
                                </div>
                              </div>
                            </div>

                            {/* Recollection Date & Location */}
                            <div className="timeline-item timeline-item-last">
                              <div className="timeline-icon-container">
                                <div className="timeline-icon">
                                  <img src={merchant_dashboard_location_icon} height={"20px"} alt="Location" />
                                </div>
                              </div>
                              <div className="timeline-content">
                                <div className={`timeline-label d-flex align-items-center gap-2 ${invoiceDetails?.latest_modified_field_flags?.recollection_location || invoiceDetails?.latest_modified_field_flags?.recollection_date ? "text-danger" : ""}`}>
                                  <span>Recollection Date & Location</span>
                                  {(invoiceDetails?.modified_field_flags?.recollection_location || invoiceDetails?.modified_field_flags?.recollection_date) && (
                                    <OverlayTrigger container={refpopup} trigger={["hover"]} placement="top" overlay={popoverHoverFocus}>
                                      <img src={manage_my_info_edit_logo} alt="Edit" width="16" className="edit-indicator" />
                                    </OverlayTrigger>
                                  )}
                                </div>
                                <div className="timeline-value location-value">
                                  <span className="timeline-date">{formatDate(invoiceDetails?.recollection_date)}</span>
                                  <span className="timeline-separator">|</span>
                                  <span className="timeline-address">{invoiceDetails?.recollection_location?.address}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="order-history-footer">
                          <button
                            className="btn invoice-download-btn"
                            onClick={handleDownloadInvoice}
                          // disabled={!invoiceDetails}
                          >
                            <span>Download Invoice</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <ImagePopupModal
                isOpen={showImagePopupModal}
                src={imageSource}
                onClose={() => setShowImagePopupModal(false)}
                message={""}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CustomerOrderDetails;


